import {defineStore} from "pinia";
import {StorageSerializers, useStorage} from "@vueuse/core";
import {ref} from "vue";
import BidPackageFileAPI from "@/api/BidPackageFileAPI";
import {createRequestDeduper} from '@/use/createRequestDeduper';

export const useBidPackageFileStore = defineStore('bidPackageFiles', () => {

  const bidPackageFiles = useStorage('bidPackageFiles', [], sessionStorage, {
    serializer: StorageSerializers.object,
  });
  const isLoading = ref<boolean>(false);
  const dedupeRequest = createRequestDeduper();
  let activeIndexKey: string | null = null;

  const clear = () => {
    activeIndexKey = null;
    bidPackageFiles.value = null;
    isLoading.value = false;
  };

  const index = async (projectId: number, bidPackageId: number, payload: any, publicProject = false) => {
    const { params } = payload;
    const key = `bid-package-files:${projectId}:${bidPackageId}:${publicProject}:${JSON.stringify(params)}`;
    activeIndexKey = key;
    bidPackageFiles.value = null;

    return dedupeRequest(key, async () => {
      isLoading.value = true;
      const data = await new BidPackageFileAPI().index(projectId, bidPackageId, params, publicProject)
        .finally(() => {
          if (activeIndexKey === key) {
            isLoading.value = false;
          }
        });

      if (activeIndexKey === key) {
        bidPackageFiles.value = data;
      }
    });
  }

  const zip = async (projectId: number, bidPackageId: number, filename: string, payload: any, publicProject = false) => {
    isLoading.value = true;
    await new BidPackageFileAPI().zip(projectId, bidPackageId, filename, payload, publicProject)
      .finally(() => isLoading.value = false);
  }

  const download = async (projectId: number, bidPackageId: number, file: any, publicProject = false) => {
    isLoading.value = true;
    await new BidPackageFileAPI().download(projectId, bidPackageId, file, publicProject)
      .finally(() => isLoading.value = false);
  }

  return {
    bidPackageFiles,
    isLoading,
    clear,
    index,
    zip,
    download,
  };
});
